import axios from "axios";

export const lpApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });
lpApi.interceptors.request.use((c) => {
  const t = localStorage.getItem("crece_lp_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const STATUS_STYLE = {
  draft: "bg-stone-100 text-stone-700",
  submitted: "bg-sky-100 text-sky-800",
  sent_to_insurer: "bg-indigo-100 text-indigo-800",
  payment_pending: "bg-amber-100 text-amber-800",
  paid: "bg-emerald-100 text-emerald-800",
  issued: "bg-emerald-800 text-white",
  rejected: "bg-red-100 text-red-700",
};

export const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });

export const fileToBase64 = (file) => new Promise((res, rej) => {
  const r = new FileReader();
  r.onload = () => res(String(r.result).split(",")[1]);
  r.onerror = rej;
  r.readAsDataURL(file);
});

export const downloadBlob = async (url, filename) => {
  const r = await lpApi.get(url, { responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(r.data);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
};

export const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  return typeof d === "string" ? d : Array.isArray(d) ? d.map((x) => x.msg || JSON.stringify(x)).join(" ") : JSON.stringify(d);
};
